import React from 'react';
import classnames from 'classnames';
import {Field} from 'formik';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import styles from './styles.module.scss';
import inputStyles from '../../styles/commonInput.module.scss';

export const StyledFieldInput = ({
                                   fieldId,
                                   type = 'text',
                                   label = '',
                                   customContainerStyles = '',
                                   customLabelStyles = '',
                                   customInputStyles = '',
                                   onChange,
                                   value = '',
                                   icon = '',
                                   ...rest
                                 }) => {
  return (
    <label className={classnames(styles.container, customContainerStyles)}>
      <div className={classnames(styles.label, customLabelStyles)}>
        {label}
      </div>
      <div className={styles.inputContainer}>
        <input
          dir={type === 'email' ? 'ltr' : 'rtl'}
          className={classnames(
            inputStyles.input,
            type === 'email' ? 'text-left' : '',
            icon ? inputStyles.withIcon : '',
            customInputStyles
          )}
          id={fieldId}
          name={fieldId}
          type={type}
          onChange={onChange}
          value={value}
          {...rest}
        />
        {icon && <img src={toAbsoluteUrl(icon)} className={styles.icon} alt="i"/>}
      </div>
    </label>
  );
};

const FieldInput = ({
                      fieldId,
                      type = 'text',
                      label = '',
                      customContainerStyles = '',
                      customLabelStyles = '',
                      customInputStyles = '',
                      onChange,
                      icon = '',
                      ...rest
                    }) => {

  const handleInputChange = ({form, field}) => e => {
    const value = e.target.value;
    if (onChange) {
      const changedValue = onChange(e);
      form.setFieldValue(field.name, changedValue);
    } else {
      form.setFieldValue(field.name, value);
    }
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({form, field}) => (
        <label className={classnames(styles.container, customContainerStyles)}>
          {label && <div className={classnames(styles.label, customLabelStyles)}>
            {label}
          </div>}
          <div className={styles.inputContainer}>
            <input
              dir={type === 'email' ? 'ltr' : 'rtl'}
              className={classnames(
                inputStyles.input,
                type === 'email' ? 'text-left' : '',
                icon ? inputStyles.withIcon : '',
                customInputStyles
              )}
              type={type}
              onChange={handleInputChange({form, field})}
              value={field.value}
              {...rest}
            />
            {icon && <img src={toAbsoluteUrl(icon)} className={styles.icon} alt="i"/>}
          </div>
        </label>
      )}
    </Field>
  );
};

export default FieldInput;